export default "/images/cd4244c3ab9da3298cd47835c313361a.png";